import RichText from './presenter';

export default RichText;
